import React from "react";
import {
  Divider,
  Button,
  Grid,
  Typography,
  IconButton,
  LinearProgress,
  Zoom,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import AttachFileIcon from '@material-ui/icons/AttachFile';

import { toast } from "react-toastify";

import RichTextEditor from "react-rte";
import { CopyToClipboard } from "react-copy-to-clipboard";

import { useQueryClient } from "react-query";
import { useFetchContext } from "../../../common/FetchContext";
import { useAttachments, useNote } from "../../../common/CommonQueries";
import { ThreadedFileViewModal } from "../../../common/threadedViewer/threadedFileViewer";
import { useDownloadImageFromUrl } from "../../../common/services/fileServices";
import { ThreadedFileDownload } from "../../../common/threadedViewer/threadedFileDownload";
import { ThreadedFileViewModalReport } from "./threadedFileViewerReport";


export const ThreadedViewerReport = ({ id, open, setOpen, showID }: any) => {
  const [openComment, setOpenComment] = React.useState(false);

  const { authAxios } = useFetchContext();
  const queryClient = useQueryClient();

  const [newComment, setNewComment] = React.useState(
    RichTextEditor.createEmptyValue()
  );



  const [disposition, setDisposition] = React.useState({ name: "", id: -1 });
  const [usedLabels, setUsedLabels] = React.useState<any[]>([]);
  const [owner, setOwner] = React.useState({ username: "", id: -1 });
  const [taggedUsers, setTaggedUsers] = React.useState<any[]>([]);
  const [files, setFiles] = React.useState<any[]>([]);
  const [selectedNoteType, setSelectedNoteType] = React.useState(0);

  const {
    data: note,
    isError: isErrorNote,
    isLoading: isLoadingNote,
    error: errorNote,
    isSuccess: isSuccessNote,
  } = useNote(id);

  

  const resetState = React.useCallback(() => {
    setDisposition({ name: note.disposition_name, id: note.disposition });
    setUsedLabels(note.labels);
    setOwner({ username: note.owner_name, id: note.owner });
    setTaggedUsers(note.tagged_users);
    setFiles(note.attachments);
    setSelectedNoteType(note.note_type);
  }, [
    note?.attachments,
    note?.disposition,
    note?.disposition_name,
    note?.labels,
    note?.note_type,
    note?.owner,
    note?.owner_name,
    note?.tagged_users,
  ]);

  React.useEffect(() => {
    if (note) {
      resetState();
    }
  }, [note, resetState]);

  React.useEffect(() => {
    if (
      note &&
      (owner.id !== note.owner ||
        disposition.id !== note.disposition ||
        selectedNoteType !== note.note_type)
    ) {
      setOpenComment(true);
    } else {
      setOpenComment(false);
    }
  }, [owner, disposition, selectedNoteType]);





  const handleClose = () => {
    setOpen(!open);
  };









  if (isLoadingNote) {
    return (
      <Dialog
        open={isLoadingNote}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        fullWidth={true}
        maxWidth={"lg"}
      >
        <DialogTitle id="scroll-dialog-title">Loading</DialogTitle>
        <DialogContent>
          <LinearProgress />
        </DialogContent>
      </Dialog>
    );
  }

  if (!note) {
    return null;
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        fullWidth={true}
        maxWidth={"lg"}
        disableBackdropClick
      >
        <DialogTitle id="scroll-dialog-title">
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Grid item xs={7}>
              <div>
              <Typography variant="h6">{note?.note_type_name} : {note?.subject} </Typography>
              </div>
            </Grid>
          
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Divider variant="fullWidth" />
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid item xs={9}>
              <>
              <Typography variant="h6">{note?.text}</Typography>

              <ThreadedFileViewModalReport files={files} />

                
              </>
            </Grid>
     
          </Grid>
        </DialogContent>
        <Divider variant="fullWidth" />
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
    
        </DialogActions>
      </Dialog>
    </div>
  );
};
